import { http, getApiCountryCode } from './http';

export const getAdPlacements = async (params = {}) => {
  const cc = getApiCountryCode();
  const merged = cc && !params.country ? { ...params, country: cc } : params;
  const res = await http.get('/api/v1/ads/placements', { params: merged });
  const data = res.data?.data ?? res.data ?? [];
  return Array.isArray(data) ? data : [];
};

export const trackAdImpression = async (payload) => {
  const cc = getApiCountryCode();
  await http.post('/api/v1/ads/events/impression', { ...payload, ...(cc && !payload.country ? { country: cc } : {}) });
};

export const trackAdClick = async (payload) => {
  const cc = getApiCountryCode();
  await http.post('/api/v1/ads/events/click', { ...payload, ...(cc && !payload.country ? { country: cc } : {}) });
};
